<template> <canvas ref="canvas"></canvas></template>
<script>
import { defineComponent } from 'vue';

import QRCode from 'qrcode';
export default defineComponent({
  props: {
      text: {
          type: String,
          required: true
      },
      size: {
          type: Number,
          required: false,
          default: 256
      },
      color: {
          type: String,
          required: false,
          default: '#000'
      },
      bgColor: {
          type: String,
          required: false,
          default: '#FFF'
      },
      errorLevel: {
          type: String,
          validator: function(value) {
              return value === 'L' || value === 'M' || value === 'Q' || value === 'H';
          },
          required: false,
          default: 'H',
      },
      maskPattern: {
          type: Number,
          required: false,
          default: 0,
      },
  },

  watch: {
      text: function() {
          this.clear();
          this.makeCode(this.text);
      },
  },

  data() {
      return {
          qrCode: {},
      };
  },

  mounted() {
      QRCode.toCanvas(this.$refs.canvas, [{ data: this.text, mode: 'Kanji' }], {
          errorCorrectionLevel: this.errorLevel,
          maskPattern: this.maskPattern,
          color: {
              dark: this.color,
              light: this.bgColor
          },
          scale: this.size / 33
      }, function(error) {
          if (error) console.error(error);
      });
  },

  methods: {
      clear: function() {
          this.qrCode.clear();
      },
      makeCode: function(text) {
          this.qrCode.makeCode(text);
      },
  },
});
</script>